import { createApiEffect } from '@/features/api/common/create-api-effect'
import { GetNewsByIdType } from '@/features/api/content/types'

export const getNewsByIdFx = createApiEffect<string, GetNewsByIdType>({
  requestMapper: (id) => ({
    method: 'GET',
    url: `/api/content-app/news/${id}/`,
  }),
})
